import { boolean, object } from 'zod';

export const InStoreOnlyConstraintSchema = object({
  isEnabled: boolean(),
});
